import type { DisciplineReportItem } from '../discipline-report'

const LIST_SEPARATOR = ', '

const asText = (value: unknown): string | null => {
  if (value === null || value === undefined) return null
  if (Array.isArray(value)) return value.length ? value.join(LIST_SEPARATOR) : null
  if (typeof value === 'boolean') return value ? 'Yes' : 'No'

  return String(value).trim() || null
}

/** The legacy tab showed the feedback only when the tutor filled more than its marker key. */
export const hasLessonFeedback = (feedback: Record<string, unknown> | null): boolean =>
  !!feedback && Object.keys(feedback).length > 1

/** What a tutor reports after a paid lesson, in the legacy order, without the unanswered questions. */
export const buildPaidFeedbackRows = (
  feedback: Record<string, unknown> | null,
  labels: { grades: Record<string, string> },
  tutorNotes: string | null,
): DisciplineReportItem[] => {
  const grade = asText(feedback?.grade)

  const rows: [string, unknown][] = [
    ['Was there a parent in the lesson?', feedback?.parent_presence],
    ['Is the topic finished?', feedback?.is_topic_finished],
    ['Lesson type', feedback?.lesson_type],
    ['Grade', grade ? labels.grades[grade] ?? grade : null],
    ['Lesson purpose', feedback?.lesson_purpose],
    ['Lesson number', feedback?.lesson_number],
    ['What do you think we need to change in the lesson?', feedback?.other],
    ['Lesson tool used', feedback?.lesson_tool],
    ['Strands covered', feedback?.strands_covered],
    ['Describe lesson tool and type if you selected "other" above', feedback?.custom_tool],
    ['Lesson notes', tutorNotes],
  ]

  return rows
    .map(([label, value]) => ({ label, value: asText(value) }))
    .filter((row): row is DisciplineReportItem => row.value !== null)
}
